/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StatusMatchResponse
 */
export interface StatusMatchResponse {
    /**
     * 
     * @type {string}
     * @memberof StatusMatchResponse
     */
    status: StatusMatchResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof StatusMatchResponse
     */
    campaignId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StatusMatchResponse
     */
    cohort?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof StatusMatchResponse
     */
    invitationExpiresAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof StatusMatchResponse
     */
    startsAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof StatusMatchResponse
     */
    endsAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof StatusMatchResponse
     */
    goldExpiresAt?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof StatusMatchResponse
     */
    nightsRequired: number;
    /**
     * 
     * @type {number}
     * @memberof StatusMatchResponse
     */
    spendRequiredUsd: number;
    /**
     * 
     * @type {number}
     * @memberof StatusMatchResponse
     */
    bookedNights: number;
    /**
     * 
     * @type {number}
     * @memberof StatusMatchResponse
     */
    bookedSpendUsd: number;
    /**
     * 
     * @type {number}
     * @memberof StatusMatchResponse
     */
    cashbackPercentage: number;
    /**
     * 
     * @type {string}
     * @memberof StatusMatchResponse
     */
    ineligibleReason?: string | null;
}


/**
 * @export
 */
export const StatusMatchResponseStatusEnum = {
    NotInvited: 'not_invited',
    Invited: 'invited',
    InviteExpired: 'invite_expired',
    Active: 'active',
    Completed: 'completed',
    Expired: 'expired',
    Ineligible: 'ineligible'
} as const;
export type StatusMatchResponseStatusEnum = typeof StatusMatchResponseStatusEnum[keyof typeof StatusMatchResponseStatusEnum];


/**
 * Check if a given object implements the StatusMatchResponse interface.
 */
export function instanceOfStatusMatchResponse(value: object): value is StatusMatchResponse {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('nightsRequired' in value) || value['nightsRequired'] === undefined) return false;
    if (!('spendRequiredUsd' in value) || value['spendRequiredUsd'] === undefined) return false;
    if (!('bookedNights' in value) || value['bookedNights'] === undefined) return false;
    if (!('bookedSpendUsd' in value) || value['bookedSpendUsd'] === undefined) return false;
    if (!('cashbackPercentage' in value) || value['cashbackPercentage'] === undefined) return false;
    return true;
}

export function StatusMatchResponseFromJSON(json: any): StatusMatchResponse {
    return StatusMatchResponseFromJSONTyped(json, false);
}

export function StatusMatchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatusMatchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'campaignId': json['campaign_id'] == null ? undefined : json['campaign_id'],
        'cohort': json['cohort'] == null ? undefined : json['cohort'],
        'invitationExpiresAt': json['invitation_expires_at'] == null ? undefined : (new Date(json['invitation_expires_at'])),
        'startsAt': json['starts_at'] == null ? undefined : (new Date(json['starts_at'])),
        'endsAt': json['ends_at'] == null ? undefined : (new Date(json['ends_at'])),
        'goldExpiresAt': json['gold_expires_at'] == null ? undefined : (new Date(json['gold_expires_at'])),
        'nightsRequired': json['nights_required'],
        'spendRequiredUsd': json['spend_required_usd'],
        'bookedNights': json['booked_nights'],
        'bookedSpendUsd': json['booked_spend_usd'],
        'cashbackPercentage': json['cashback_percentage'],
        'ineligibleReason': json['ineligible_reason'] == null ? undefined : json['ineligible_reason'],
    };
}

export function StatusMatchResponseToJSON(json: any): StatusMatchResponse {
    return StatusMatchResponseToJSONTyped(json, false);
}

export function StatusMatchResponseToJSONTyped(value?: StatusMatchResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'campaign_id': value['campaignId'],
        'cohort': value['cohort'],
        'invitation_expires_at': value['invitationExpiresAt'] == null ? value['invitationExpiresAt'] : value['invitationExpiresAt'].toISOString(),
        'starts_at': value['startsAt'] == null ? value['startsAt'] : value['startsAt'].toISOString(),
        'ends_at': value['endsAt'] == null ? value['endsAt'] : value['endsAt'].toISOString(),
        'gold_expires_at': value['goldExpiresAt'] == null ? value['goldExpiresAt'] : value['goldExpiresAt'].toISOString(),
        'nights_required': value['nightsRequired'],
        'spend_required_usd': value['spendRequiredUsd'],
        'booked_nights': value['bookedNights'],
        'booked_spend_usd': value['bookedSpendUsd'],
        'cashback_percentage': value['cashbackPercentage'],
        'ineligible_reason': value['ineligibleReason'],
    };
}

